// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExecutedMints2Step } from '@hooks/queries/registry/mint/useExecutedMints2Step';
import useFailedMints3Step from '@hooks/queries/registry/mint/useFailedMints';
import useMintRequests3Step from '@hooks/queries/registry/mint/useMintRequests';
import { useMintRequests2Step } from '@hooks/queries/registry/mint/useMintRequests2Step';
import { useRejectedMints2Step } from '@hooks/queries/registry/mint/useRejectedMints2Step';
import useExecutedMints3Step from './useExecutedMints';
import useRejectedMints from './useRejectedMints';

export const useGetMintQueries = () => {
  // two step
  const mintRequest = useMintRequests2Step();
  const executedMint = useExecutedMints2Step();
  const rejectedMints = useRejectedMints2Step();

  // 3 step
  const mintRequest3Step = useMintRequests3Step();
  const executedMints3Step = useExecutedMints3Step();
  const failedMints3Step = useFailedMints3Step();
  const rejectedMints3Step = useRejectedMints();

  return {
    mintRequest,
    mintRequest3Step,
    executedMint,
    executedMints3Step,
    rejectedMints,
    rejectedMints3Step,
    failedMints3Step,
  };
};
